import useUserSettingMutation from "./useUserSettingMutation";

const useHarvestRecordingSetting = () => {
  const { update, isUpdating } = useUserSettingMutation("harvestRecording");

  return { updateHarvestRecordingSetting: update, isUpdating };
};

export default useHarvestRecordingSetting;
